import React, { useMemo } from 'react';
import { ErrorWidget, LoaderWidget, useI18n } from '@jarvis/react-portal-addons';
import { IconBuilding } from '@veneer/core';
import useAccountApiCall from '../../../hooks/useAccountApiCall';
import SideCardTemplate from '../SideCards/SideCardTemplate';
import {
  AddonsWidgetContainer,
  Container,
  IconContainer,
  InfoContainer,
  InfoItem,
  InfoLabel,
  InfoValue,
  WorkspaceName,
} from './styles';

export const WorkspaceWidget = () => {
  const { t } = useI18n();

  const accountData = useAccountApiCall({ init: true });

  const Content = useMemo(() => {
    if (accountData?.pending) {
      return (
        <AddonsWidgetContainer data-testid="workspace-widget-card-loading">
          <LoaderWidget />
        </AddonsWidgetContainer>
      );
    }

    if (accountData?.error || !accountData?.data) {
      return (
        <AddonsWidgetContainer data-testid="workspace-widget-card-error">
          <ErrorWidget
            i18n={{
              retry: t('dashboard.error.retry'),
              message: t('dashboard.error.bodyCopy'),
            }}
            onRetry={() => accountData.forceFetch()}
          />
        </AddonsWidgetContainer>
      );
    }

    const { resourceId, accountName, regionId } = accountData.data;

    return (
      <Container data-testid="workspace-item">
        <IconContainer data-testid="workspace-item-icon">
          <IconBuilding
            color="black"
            size={36}
          />
        </IconContainer>
        <InfoContainer>
          <WorkspaceName
            className="label-regular"
            data-testid="workspace-item-name"
          >
            {accountName}
          </WorkspaceName>
          <InfoItem>
            <InfoLabel className="label-small" data-testid="workspace-card-uid-string">
              {t('dashboard.workspaceCard.uuid')}
            </InfoLabel>
            <InfoValue className="label-small" data-testid="workspace-item-uid">
              {resourceId}
            </InfoValue>
          </InfoItem>
          <InfoItem>
            <InfoLabel className="label-small" data-testid="workspace-card-country-string">
              {t('dashboard.workspaceCard.countryRegion')}
            </InfoLabel>
            <InfoValue className="label-small" data-testid="workspace-item-region">
              {t(`dashboard.workspaceCard.countries.${regionId}`)}
            </InfoValue>
          </InfoItem>
        </InfoContainer>
      </Container>
    );
  }, [accountData, t]);

  return (
    <SideCardTemplate
      title={t('dashboard.workspaceCard.header')}
      content={Content}
      data-testid="workspace-widget-card"
    />
  );
};

export default WorkspaceWidget;
